import { isDeepEqual } from "remeda";
import { OrganisationService } from "../OrganisationService";
import {
  ApplicationUser,
  Client,
  LocationEnum,
  PostalAddress,
  ProductTypeEnum,
  ShareDealDTO,
} from "@src/apis/ModularClient";
import ProductHelper from "@js/helpers/ProductHelper";

export class SharedCriteriaService {
  dataLoading: boolean;
  previousUrl: string;

  static $inject = ["$q", "OrganisationService"];

  constructor(
    private $q: ng.IQService,
    private organisationService: OrganisationService,
  ) {}

  /**
   * Sets a clientDto value to null
   * @param shareDealDto
   * @returns updated shareDealDto
   */
  clearExistingUserOnShareDealDto(shareDealDto): ShareDealDTO {
    if (shareDealDto.clientDto) {
      shareDealDto.clientDto.firstName = null;
      shareDealDto.clientDto.lastName = null;
      shareDealDto.clientDto.email = null;
      shareDealDto.clientDto.phoneNumber = null;
    }

    return shareDealDto;
  }

  /**
   * Returns a default search name depending on product type
   * @param shareDealDto
   * @returns default search name
   */

  defaultSearchName(productType: ProductTypeEnum, isRegulatedBridge: boolean = false) {
    var currentdate = new Date();
    var productTypeDisplayText = "";

    if (isRegulatedBridge) {
      productTypeDisplayText = "Regulated Bridge";
    } else {
      productTypeDisplayText = ProductHelper.getProductTypeDisplayText(productType);
    }

    return (
      "My " +
      productTypeDisplayText +
      " Loan Search " +
      currentdate.getDate() +
      "/" +
      (currentdate.getMonth() + 1) +
      "/" +
      currentdate.getFullYear()
    );
  }

  setNewSearch(dealDto, snapshotDealDto): void {
    var criteriaChanged = true;
    //Store that this is a new search
    if (sessionStorage.getItem("skip") == "true") {
      criteriaChanged = !isDeepEqual(dealDto, snapshotDealDto);
    }

    if (window.self == window.top) {
      sessionStorage.setItem("newSearch", criteriaChanged.toString());
    } else {
      this.organisationService.sendDataToParent("newSearch", criteriaChanged.toString());
    }
  }

  setClientDtoDataForEnterpriseSearch(user: ApplicationUser, brokerageOrgId: number, clientDto: Client): Client {
    let userFullName = user.fullName;
    let spaceIndex = userFullName.indexOf(" ");

    let firstName = "";
    let lastName = "";

    // if not space has been added to the name then put the whole name in the first name field
    if (spaceIndex == -1) {
      firstName = userFullName;
    } else {
      firstName = userFullName.substring(0, userFullName.indexOf(" "));
      lastName = userFullName.substring(userFullName.indexOf(" ") + 1);
    }

    clientDto = {
      firstName: firstName,
      lastName: lastName,
      email: user.email,
      phoneNumber: user.phoneNumber,
      brokerOrganisationId: brokerageOrgId,
      postalAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      } as PostalAddress,
    } as Client;

    return clientDto;
  }

  getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  getRandomPostcode() {
    //TODO This is code that was conflicting during the merge between BorrowerNotifications and DevFinDeal. Leaving here in case it shoudl be re-instated:
    //const postcodes = [
    //    "SW1A 1AA", // Buckingham Palace
    //    "SW1A 2AA", // Downing Street
    //    "E1 6AN",   // Near Shoreditch, London
    //    "B1 1TB",   // Birmingham City Centre
    //    "G1 1QX",   // Glasgow City Centre
    //    "L1 8JQ",   // Liverpool City Centre
    //    "M1 1AG",   // Manchester City Centre
    //    "S1 2BJ",   // Sheffield City Centre
    //    "NE1 1EE",  // Newcastle City Centre
    //    "CF10 1EP"  // Cardiff City Centre
    //];

    //const randomIndex = Math.floor(Math.random() * postcodes.length);
    //return postcodes[randomIndex];

    var postCodeList = [
      "SW1",
      "GL1",
      "BS32",
      "DH2 1JR",
      "SR2 9DJ",
      "LL30 2AS",
      "PO32 6BT",
      "M27 5TR",
      "EH15 3PQ",
      "WD3 8QB",
    ];

    return postCodeList[this.getRandomIntInclusive(0, 9)];
  }

  getRegionByPostcode(postcode) {
    var region = {
      SW1: LocationEnum.London,
      GL1: LocationEnum.SouthWest,
      BS32: LocationEnum.SouthWest,
      "DH2 1JR": LocationEnum.Wales,
      "SR2 9DJ": LocationEnum.SouthWest,
      "LL30 2AS": LocationEnum.Wales,
      "PO32 6BT": LocationEnum.SouthEast,
      "M27 5TR": LocationEnum.NorthWest,
      "EH15 3PQ": LocationEnum.Scotland,
      "WD3 8QB": LocationEnum.EastofEngland,
    };

    return region[postcode];
  }

  storeEnterpriseLinkType(linkType: string) {
    if (window.self == window.top) {
      sessionStorage.setItem("enterpriseLinkType", linkType);
    } else {
      this.organisationService.sendDataToParent("enterpriseLinkType", linkType);
    }
  }

  getIsDataLoading() {
    return this.dataLoading;
  }

  setIsDataLoading(dataLoading) {
    this.dataLoading = dataLoading;
  }

  getPreviousUrl() {
    return this.previousUrl;
  }

  setPreviousUrl(previousUrl) {
    this.previousUrl = previousUrl;
  }
}

// AngularJS service registration
